export default __webpack_public_path__ + "static/media/marenda_biggs.5a5550d9.jpg";